import type { Language } from "../hooks/useLanguageDetection";

export const SUPPORTED_LANGUAGES: Language[] = [
  {
    id: 1,
    language_code: "en",
    language_name: "English",
    flag_image_url: "https://flagcdn.com/w320/gb.png",
  },
  {
    id: 2,
    language_code: "de",
    language_name: "German",
    flag_image_url: "https://flagcdn.com/w320/de.png",
  },
  {
    id: 3,
    language_code: "fr",
    language_name: "French",
    flag_image_url: "https://flagcdn.com/w320/fr.png",
  },
  {
    id: 4,
    language_code: "nl",
    language_name: "Dutch",
    flag_image_url: "https://flagcdn.com/w320/nl.png",
  },
  {
    id: 5,
    language_code: "hi",
    language_name: "Hindi",
    flag_image_url: "https://flagcdn.com/w320/in.png",
  },
  {
    id: 6,
    language_code: "es",
    language_name: "Spanish",
    flag_image_url: "https://flagcdn.com/w320/es.png",
  },
  {
    id: 7,
    language_code: "pt",
    language_name: "Portuguese",
    flag_image_url: "https://flagcdn.com/w320/pt.png",
  },
  {
    id: 8,
    language_code: "it",
    language_name: "Italian",
    flag_image_url: "https://flagcdn.com/w320/it.png",
  },
];

/** Each language's name in that language, for the language selector (language_name stays English for data and forms). */
export const NATIVE_LANGUAGE_NAMES: Record<string, string> = {
  en: "English",
  de: "Deutsch",
  fr: "Français",
  nl: "Nederlands",
  hi: "हिन्दी",
  es: "Español",
  pt: "Português",
  it: "Italiano",
};

/** The native name of a language, falling back to the given (English) name. */
export const nativeLanguageName = (code: string, fallback: string): string =>
  NATIVE_LANGUAGE_NAMES[code] ?? fallback;

// Optional: Helper function to get language by code
export const getLanguageByCode = (code: string): Language | undefined => {
  return SUPPORTED_LANGUAGES.find((lang) => lang.language_code === code);
};

// Optional: Get default language (English)
export const getDefaultLanguage = (): Language => {
  return SUPPORTED_LANGUAGES[0]!;
};
